export default __webpack_public_path__ + "74bf8b5cc4fc3e968b012e0019efb10c.svg";